import FullScreenLoader from "../../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState } from "react";
import { ReservationSaveMapping } from "../../../Services/Service";
import swal from "sweetalert";
import { useProperty } from "../../../PropertyContext";
import '../PropertyDetails.css';

// Props received from parent (RateInventory):
// Pms, ratecode, mealplan, rooms, editData, onSaveSuccess, modalId
export const EditRateInventory = ({ Pms, ratecode, mealplan, rooms, editData, onSaveSuccess, modalId }) => {
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);

    const [selectedRate, setSelectedRate] = useState("");
    const [selectedMealPlan, setSelectedMealPlan] = useState("");
    const [selectedRoom, setSelectedRoom] = useState("");
    const [baseRate, setBaseRate] = useState(0);
    const [doubleRate, setDoubleRate] = useState(0);
    const [tripleRate, setTripleRate] = useState(0);
    const [extraBed, setExtraBed] = useState(0);
    const [extraAdultRate, setExtraAdultRate] = useState(0);
    const [extraChildRate, setExtraChildRate] = useState(0);
    const [effectiveFrom, setEffectiveFrom] = useState("");
    const [effectiveTo, setEffectiveTo] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [editId, setEditId] = useState(0);

    // ── Pre-fill form when editData changes ──────────────────
    useEffect(() => {
        if (editData) {
            setEditId(editData.RateCodeMealPlanID);
            setSelectedRate(editData.RateCodeID || "");
            setSelectedMealPlan(editData.MealPlanID || "");
            setSelectedRoom(editData.RoomTypeID || "");
            setBaseRate(editData.BaseRate || 0);
            setDoubleRate(editData.DoubleRate || 0);
            setTripleRate(editData.TripleRate || 0);
            setExtraBed(editData.ExtraBed || 0);
            setExtraAdultRate(editData.ExtraAdultRate || 0);
            setExtraChildRate(editData.ExtraChildRate || 0);
            setEffectiveFrom(editData.EffectiveFrom ? editData.EffectiveFrom.split("T")[0] : "");
            setEffectiveTo(editData.EffectiveTo ? editData.EffectiveTo.split("T")[0] : "");
            setIsActive(editData.IsActive === 1);
        }
    }, [editData]);

    const resetForm = () => {
        setEditId(0);
        setSelectedRate("");
        setSelectedMealPlan("");
        setSelectedRoom("");
        setBaseRate(0);
        setDoubleRate(0);
        setTripleRate(0);
        setExtraBed(0);
        setExtraAdultRate(0);
        setExtraChildRate(0);
        setEffectiveFrom("");
        setEffectiveTo("");
        setIsActive(true);
    };

    const handleSubmit = async () => {
        if (!selectedMealPlan || !selectedRoom) {
            swal("Error", "Please select Meal Plan and Room", "error");
            return;
        }
        try {
            setLoading(true);
            await ReservationSaveMapping(
                selectedProperty?.PropertyID || 0,
                editId,
                selectedRate || 0,
                selectedMealPlan,
                selectedRoom,
                baseRate,
                doubleRate,
                tripleRate,
                extraBed,
                extraAdultRate,
                extraChildRate,
                effectiveFrom,
                effectiveTo,
                isActive ? 1 : 0
            );

            if (onSaveSuccess) await onSaveSuccess();

            swal("Data Saved Successfully", {
                icon: "success",
                buttons: { confirm: { text: "OK", className: "btn btn-success" } },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById(modalId)
                );
                if (modal) modal.hide();
                resetForm();
            });
        } catch (error) {
            console.log("Error saving mapping", error);
            swal("Failed to save data!", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <FullScreenLoader />
            )}
            <div className="row rate-inventory-form">
                {Pms?.PMS === "Opera" && (
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Rate Code</label>
                            <select className="form-control form-select" value={selectedRate}
                                onChange={(e) => setSelectedRate(e.target.value)}>
                                <option value="">Select code</option>
                                {ratecode.map((item) => (
                                    <option key={item.RateCodeID} value={item.RateCodeID}>
                                        {item.Name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label">Meal Plan</label>
                        <select className="form-control form-select" value={selectedMealPlan}
                            onChange={(e) => setSelectedMealPlan(e.target.value)}>
                            <option value="">Select Plan</option>
                            {mealplan.map((item) => (
                                <option key={item.MealPlanID} value={item.MealPlanID}>
                                    {item.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="mb-3">
                        <label className="form-label">Room Name</label>
                        <select className="form-control form-select" value={selectedRoom}
                            onChange={(e) => setSelectedRoom(e.target.value)}>
                            <option value="">Select Room</option>
                            {rooms.map((room) => (
                                <option key={room.RoomID} value={room.RoomID}>
                                    {room.RoomName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="mb-3">
                        <label className="form-label">Base Rate</label>
                        <input type="number" className="form-control" value={baseRate} min={0}
                            onChange={(e) => setBaseRate(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="mb-3">
                        <label className="form-label">Double Rate</label>
                        <input type="number" className="form-control" value={doubleRate} min={0}
                            onChange={(e) => setDoubleRate(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="mb-3">
                        <label className="form-label">Triple Rate</label>
                        <input type="number" className="form-control" value={tripleRate} min={0}
                            onChange={(e) => setTripleRate(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="mb-3">
                        <label className="form-label">Extra Bed</label>
                        <input type="number" className="form-control" value={extraBed} min={0}
                            onChange={(e) => setExtraBed(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="mb-3">
                        <label className="form-label">Extra Adult Rate</label>
                        <input type="number" className="form-control" value={extraAdultRate} min={0}
                            onChange={(e) => setExtraAdultRate(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="mb-3">
                        <label className="form-label">Extra Child Rate</label>
                        <input type="number" className="form-control" value={extraChildRate} min={0}
                            onChange={(e) => setExtraChildRate(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="mb-3">
                        <label className="form-label">Effective From</label>
                        <input type="date" className="form-control" value={effectiveFrom}
                            onChange={(e) => setEffectiveFrom(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="mb-3">
                        <label className="form-label">Effective To</label>
                        <input type="date" className="form-control" value={effectiveTo}
                            onChange={(e) => setEffectiveTo(e.target.value)} />
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="mb-3 d-flex align-items-center">
                        <label className="form-label me-2 mb-0">Active</label>
                        <input type="checkbox" checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)} />
                    </div>
                </div>
                <div className="col-sm-12 mt-3 text-end">
                    <button className="btn btn-primary btn-sm" onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </div>
        </>
    );
};
